import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Facebook, Instagram, Youtube, Phone, Mail, GraduationCap } from 'lucide-react';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo & Description */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_286e4964-f4c4-4bbc-b747-2b335ee2c3b0/artifacts/2w7jy3xv_OFFROAD%20ITALIA%20LOGO%202025.jpeg" 
              alt="Offroad Italia" 
              className="h-16 w-auto mb-4 bg-white p-2 rounded"
            />
            <p className="text-gray-400 text-sm">
              DAL 2011 ORGANIZZIAMO TOUR OFFROAD IN EUROPA, AFRICA E SUDAMERICA.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('contact.title')}</h3>
            <div className="space-y-3">
              <a 
                href="https://wa.me/393793793030?text=Ciao%2C%20vorrei%20informazioni%20sugli%20eventi%20Offroad%20Italia" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-gray-400 hover:text-white transition-colors"
              >
                <Phone size={18} />
                <span>+39 379 379 3030</span>
              </a>
              <a 
                href="mailto:info@offroaditalia.com" 
                className="flex items-center space-x-2 text-gray-400 hover:text-white transition-colors"
              >
                <Mail size={18} />
                <span>info@offroaditalia.com</span>
              </a>
            </div>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.followUs')}</h3>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/Offroaditaliaenduring/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-blue-600 p-3 rounded-full hover:bg-blue-700 transition-colors"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://www.instagram.com/ugofilosa/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gradient-to-r from-purple-600 to-pink-600 p-3 rounded-full hover:from-purple-700 hover:to-pink-700 transition-colors"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://www.youtube.com/c/UgoFilosa"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-red-600 p-3 rounded-full hover:bg-red-700 transition-colors"
              >
                <Youtube size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="text-center text-gray-400 text-sm mb-4">
            <p className="mb-2">
              <strong className="text-gray-300">SERVICE 360 TOTAL SOLUTIONS LTD</strong>
            </p>
            <p className="mb-1">VAT: BG205967958</p>
            <p className="mb-1">Str. Dr Anastasiya Zhelezkova 35, 9000 Varna, Bulgaria</p>
            <p className="mb-3">Rappresentante Legale: Ugo Filosa</p>
            <p>&copy; {new Date().getFullYear()} Offroad Italia. {t('footer.rights')}.</p>
          </div>
          
          <div className="flex flex-wrap justify-center gap-6 text-gray-400 text-sm">
            <Link to="/corso-osmand" className="hover:text-white transition-colors flex items-center">
              <GraduationCap size={16} className="mr-1" />
              {t('nav.corsoOsmand')}
            </Link>
            <Link to="/privacy-policy" className="hover:text-white transition-colors">
              {t('footer.privacy')}
            </Link>
            <Link to="/cookie-policy" className="hover:text-white transition-colors">
              {t('footer.cookies')}
            </Link>
            <Link to="/terms" className="hover:text-white transition-colors">
              {t('footer.terms')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
